import httpClient from "Api/httpClient";

const END_POINT = "/departments";

const getDepartments = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getDepartment = (department_id) => {
    if (!department_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + department_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printDepartment = (department_id) => {
    if (!department_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?department_id=" + department_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createDepartments = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateDepartments = (payload, department_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + department_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteDepartments = (department_id) => {
    const DELETE_END_POINT = END_POINT + "/" + department_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getDepartments, getDepartment, printDepartment, createDepartments, updateDepartments, deleteDepartments };
